import nextArrow from './icon_next.svg';
import logo from './logo.svg';
import addBtn from './add_btn.svg';
import iconSend from './icon_send.svg';
import iconSent from './icon_sent.svg';
import poweredBy from './powered_by.svg';
import photoPlaceholder from './photo.svg';
import profileOptsBg from './profile_popup_bg.svg';

export {
  nextArrow,
  logo,
  addBtn,
  iconSend,
  iconSent,
  poweredBy,
  photoPlaceholder,
  profileOptsBg
}



// WEBPACK FOOTER //
// ./src/assets/index.js